{
  "close": "Fechar",
  "notifications": "{count, plural, one {# notificação} other {# notificações}}."
}
